<template>
	<div>
		<div class="registration-title">
			<h2 class="text-dark text-thin">{{ this.modelTitle }}</h2>
			<div>
				<button class="crm-button" @click.prevent="openAddModal" title="Adicionar">
					<div class="flex ai-c fgap1">
						<plus-icon :size="20" color="currentColor" /> Adicionar
					</div>
				</button>
			</div>
		</div>
    
    	<hr class="mb-4" />

		<TableSSR 
		    @perPageChange="setPerPage($event.perPage)"
			@pageChange="setPage($event.page)"
			:columns="tableColumns" 
			:current-page="page"
			:tableData="tableData"
			:last-page="lastPage"
			:totalRecords="totalRecords"
			:table-config="tableConfig"
		>
			<template #name="{ item }">
				<div v-if="'name' in item">
					<p v-if="item.name" class="flex fd-c"> 
						<span class="text-color-primary">{{ item.name }}</span>
					</p>
					<p v-else> - </p>
				</div>
			</template>
			<template #type="{ item }">
				<div v-if="'type' in item" class="text-center">
					<p v-if="item.type">
						{{ getTypeLabel(item.type) }}
					</p>
					<p v-else> - </p>
				</div>
			</template>
			<template #codeRfb="{ item }">
				<div v-if="'codeRfb' in item" class="text-center">
					<p v-if="item.codeRfb">{{ item.codeRfb }}</p>
					<p v-else> - </p>
				</div>
			</template>
			<template #codeIso="{ item }">
				<div v-if="'codeIso' in item" class="text-center">
					<p v-if="item.codeIso">{{ item.codeIso }}</p>
					<p v-else> - </p>
				</div>
			</template>
			<template #unlocode="{ item }">
				<div v-if="'unlocode' in item" class="text-center">
					<p v-if="item.unlocode">{{ item.unlocode }}</p>
					<p v-else> - </p>
				</div>
			</template>
			<template #state="{ item }">
				<div>
					<p v-if="item.address && item.address.state">{{ item.address.state }}</p>
					<p v-else> - </p>
				</div>
			</template>
			<template #city="{ item }">
				<div>
					<p v-if="item.address && item.address.city">{{ item.address.city }}</p>
					<p v-else> - </p>
				</div>
			</template>
			<template #countryName="{ item }">
				<div>
					<p v-if="item.address && item.address.countryName">{{ item.address.countryName }}</p>
					<p v-else> - </p>
				</div>
			</template>
			<template #imo="{ item }" >
				<div v-if="'imo' in item" class="text-center">
					<p v-if="item.imo">{{ item.imo }}</p>
					<p v-else> - </p>
				</div>
			</template>
			<template #mms="{ item }">
				<div v-if="'mms' in item" class="text-center">
					<p v-if="item.mms">{{ item.mms }}</p>
					<p v-else> - </p>
				</div>
			</template>
			<template #flag="{ item }">
				<div v-if="'flag' in item" class="text-center">
					<p v-if="item.flag">{{ item.flag }}</p>
					<p v-else> - </p>
				</div>
			</template>
			<!-- Column Actions -->
			<template #actions="{ item }">
				<div class="flex gap1 jc-c">
					<a class="edit-button" href="#" @click.prevent="openEditModal(item)" title="Editar">
						<EditIcon :size="16" />
					</a>
				</div>
			</template>
			<!-- Column Actions -->
		</TableSSR>

		<VModal
			:handler="modalOpen"
			@requestClose="() => closeModal()"
			:title="data.id ? 'Atualizar Cadastro' : 'Adicionar'"
			description=""
			:width="1000"
			:height="0"
		>
			<template #content>
				<form @submit.prevent class="registration-form">
					<div class="span-12 registration-form">
						<div class="span-12 flex ai-c jc-sb	">
							<h4 class="text-dark mb-0">Dados Gerais</h4>
							<p style="margin-bottom: 0">Os campos marcados com <span class="tx-danger">*</span> são obrigatórios.</p>
						</div>

						<div class="span-12 registration-form">
							<div class="span-8" v-if="'name' in data">
								<v-input type="text" name="name" label="Nome" :mask="[]" :requiredFlag="true" v-model="data.name" :class="{'input-danger': getError('name') }" />
								<div class="field-error" v-if="getError('name')">
									{{ getError('name') }}
								</div>
							</div>
							<div class="span-4" v-if="'type' in data">
								<select-wrapper v-model="data.type" :options="typeOptions" label="Tipo" :requiredFlag="true" classModify="input-modify" :class="{'input-danger': getError('type') }" />
								<div class="field-error" v-if="getError('type')">
									{{ getError('type') }}
								</div>
							</div>
						</div>
						<div class="span-12 registration-form">
							<div class="span-4" v-if="'codeRfb' in data">
								<v-input type="text" name="codeRfb" label="Código RFB" v-model="data.codeRfb" />
							</div>
							<div class="span-4" v-if="'codeIso' in data">
								<v-input type="text" name="codeIso" label="Código ISO" v-model="data.codeIso" />
							</div>
							<div class="span-4" v-if="'unlocode' in data">
								<v-input type="text" name="unlocode" label="UN/LOCODE" v-model="data.unlocode" />
							</div>
							<div class="span-4" v-if="'imo' in data">
								<v-input type="text" name="imo" label="IMO" v-model="data.imo" />
							</div>
							<div class="span-4" v-if="'mms' in data">
								<v-input type="text" name="mms" label="MMS" v-model="data.mms" />
							</div>
							<div class="span-4" v-if="'flag' in data">
								<v-input type="text" name="flag" label="Bandeira" v-model="data.flag" />
							</div>
						</div>
					</div>

					<div class="span-12" v-if="'address' in data">
						<hr class="mt-0 mb-0">
					</div>
					
					<div class="span-12 registration-form mb-3" v-if="'address' in data">
						<div class="span-12">
							<h4 class="text-dark mb-0">Informações de Endereço</h4>
						</div>
						<div class="span-4" v-if="'address' in data">
							<v-input type="text" name="state" label="Estado" v-model="data.address.state"/>
						</div>
						<div class="span-4" v-if="'address' in data">
							<v-input type="text" name="city" label="Cidade" v-model="data.address.city" :requiredFlag="true" :class="{'input-danger': getError('address.city') }" />
							<div class="field-error" v-if="getError('address.city')">
								{{ getError('address.city') }}
							</div>
						</div>
						<div class="span-4" v-if="'address' in data">
							<v-input type="text" name="countryName" label="País" v-model="data.address.countryName" :requiredFlag="true" :class="{'input-danger': getError('address.countryName') }" />
							<div class="field-error" v-if="getError('address.countryName')">
								{{ getError('address.countryName') }}
							</div>
						</div>
					</div>
				</form>
			</template>

			<template #footer>
				<div class="flex ai-c jc-c fgap2">
					<button class="crm-button red" @click.prevent="() => closeModal()" >
						Cancelar
					</button>
					<button class="crm-button" @click.prevent="saveData" >
						Salvar
					</button>
				</div>
			</template>
		</VModal>

  	</div>
</template>

<script>
import SelectWrapper from "@/components/SelectWrapper.vue";
import EditIcon from "@/components/icons/EditIcon.vue";
import PlusIcon from "@/components/crm/Icons/Plus.vue";
import TableSSR from "@/components/TableSSR.vue";
import VModal from "@/components/VModal.vue";
import VInput from "@/components/VInput.vue";
import Swal from "sweetalert2";
import config from "@/config";
import * as yup from "yup";
import Axios from "axios";

export default {
	name: 'RegistrationsVariousList',
	components : {
		PlusIcon,
		TableSSR,
		EditIcon,
		VModal,
		VInput,
		SelectWrapper,
	},
	props: {
		registration: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			modelTitle: '',
			urlGetDataList: '',
			urlSaveData: '',
			tableData: [],
			formErrors: [],
			data: {},
			tableColumns: [],
			perPage: 10,
			page: 1,
			typeOptions: [],
			modalOpen: false,
			registrationConfig: {
				'locais-de-embarque': {
					title: 'Listagem de Locais de Embarque',
					urlGetDataList: `${config.env.API_DEFAULT.host}/places`,
					urlSaveData: `${config.env.API_DEFAULT.host}/places`,
					typeOptions: [
						{ label: "Porto", value: "SEAPORT" },
						{ label: "Aéroporto", value: "AIRPORT" },
						{ label: "Fronteira", value: "BORDER" },
						{ label: "Navio", value: "VESSEL" },
						{ label: "Avião", value: "AIRCRAFT" },
						{ label: "Caminhão", value: "TRUCK" }
					],
					tableColumns: [
						{ label: 'Nome', field: 'name' },
						{ label: 'Tipo', field: 'type', class: 'text-center' },
						{ label: 'Código RFB', field: 'codeRfb', class: 'text-center' },
						{ label: 'Código ISO', field: 'codeIso', class: 'text-center' },
						{ label: 'UN/LOCODE', field: 'unlocode', class: 'text-center' },
						{ label: 'Estado', field: 'state' },
						{ label: 'Cidade', field: 'city' },
						{ label: 'País', field: 'countryName' },
						{ label: 'Ações', field: 'actions', class: 'text-center' },
					],
					defaultData: {
						name: '',
						type: '',
						codeRfb: '',
						codeIso: '',
						unlocode: '',
						address: {
							state: '',
							city: '',
							countryName: '',
						},
					}
				},
				'veiculos': {
					title: 'Listagem de Veículos',
					urlGetDataList: `${config.env.API_DEFAULT.host}/vehicles`,
					urlSaveData: `${config.env.API_DEFAULT.host}/vehicles`,
					typeOptions: [
						{ label: "Navio", value: "VESSEL" },
						{ label: "Avião", value: "AIRCRAFT" },
						{ label: "Caminhão", value: "TRUCK" }
					],
					tableColumns: [
						{ label: 'Nome', field: 'name' },
						{ label: 'Tipo', field: 'type', class: 'text-center' },
						{ label: 'IMO', field: 'imo', class: 'text-center' },
						{ label: 'MMS', field: 'mms', class: 'text-center' },
						{ label: 'Bandeira', field: 'flag', class: 'text-center' },
						{ label: 'Ações', field: 'actions', class: 'text-center' },
					],
					defaultData: {
						name: '',
						type: '',
						imo: '',
						mms: '',
						flag: '',
					}
				}
			}
		};
	},
	computed: {
		tableConfig() {
			return {
				useSearch: true,
				centeredCell: false,
				showRecords: true,
				paginationTop: true,
				typeSearch: 'list',
				showPerPageTop: true,
				showPerPageBottom: true,
				perPage: this.perPage,
			};
		},
		totalRecords() {
			return this.tableData.length > 0 ? this.tableData.length : 0;
		},
		lastPage() {
			return Math.ceil(this.totalRecords / this.perPage) || 1;
		}
	},
	methods: {
		setPerPage(perPage) {
			this.perPage = perPage;
		},
		setPage(page) {
			this.page = page;
		},
		getError(field) {
			if (this.formErrors.length === 0) {
				return null;
			}
			const item = this.formErrors.find((e) => e.path === field || e.type === field);
			return item?.message || null;
		},
		getTypeLabel(typeValue) {
			const option = this.typeOptions.find((option) => option.value === typeValue);
			return option?.label || '';
		},
		async openEditModal(item) {
			try {
				const response = await Axios.get(`${this.urlGetDataList}/${item.id}`);
				this.data = response.data.data;
				this.modalOpen = true;
			} catch (e) {
				this.showErrorMessage("Erro", "Erro ao abrir o modal de edição!");
			}
		},
		initializeRegistrationType() {
			const config = this.registrationConfig[this.registration];
			if (!config) {
				console.error(`Configuração não encontrada para: ${this.registration}`);
				return;
			}

			this.modelTitle = config.title;
			this.urlGetDataList = config.urlGetDataList;
			this.urlSaveData = config.urlSaveData;
			this.typeOptions = config.typeOptions;
			this.tableColumns = config.tableColumns;
			this.setDataByType();
		},
		setDataByType() {
			const config = this.registrationConfig[this.registration];
			if (config && config.defaultData) {
				this.data = JSON.parse(JSON.stringify(config.defaultData));
			}
		},
		getValidationSchema() {
			if (this.registration === 'locais-de-embarque') {
				return yup.object().shape({
					name: yup.string().required('O Nome é obrigatório'),
					type: yup.string().required('O Tipo é obrigatório'),
					address: yup.object().shape({
						city: yup.string().required('A Cidade é obrigatória'),
						countryName: yup.string().required('O País é obrigatório'),
					}),
				});
			} else if (this.registration === 'veiculos') {
				return yup.object().shape({
					name: yup.string().required('O Nome é obrigatório'),
					type: yup.string().required('O Tipo é obrigatório'),
				});
			}
			return null;
		},
		showSuccessMessage() {
			Swal.fire({
				title: this.modelTitle,
				text: "Salvo com sucesso!",
				type: "success",
			});
		},
		showErrorMessage(title, message) {
			Swal.fire({
				title: title,
				text: message,
				type: "error",
			});
		},
		showValidationErrors(error) {
			this.formErrors = error.inner;
			let html = '<div class="text-left pl-4 pr-4 pt-4"><p>Por favor, preencha os campos obrigatórios abaixo!</p>';
			if (error.errors.length > 0) {
				html += '<ul>';
				error.errors.forEach(errorMsg => {
					html += `<li class="mb-2">${errorMsg}</li>`;
				});
				html += '</ul>';
			}
			html += '</div>';
		
			Swal.fire({
				title: 'Adicionar',
				html: html,
				type: 'error',
				customClass: 'alert-error'
			});
		},
		showApiErrorMessage(error) {
			const message = error.response?.data?.data || error.response?.data?.message || 'Não foi possível adicionar';
			Swal.fire({
				title: "Adicionar",
				html: `<p>${message}</p>`,
				type: "error",
			});
		},
		async getDataList() {
			this.$store.commit("setLoading", {
				show: true,
				label: "Carregando...",
				description: "Recuperando listagem de registros.",
			});

			try {
				const response = await Axios.get(this.urlGetDataList);
				this.tableData = response.data.data;
			} catch (e) {
				this.showErrorMessage("Cadastros Operacionais", "Erro ao listar os registros!");
			} finally {
				this.$store.commit("setLoading", {
					show: false,
				});
			}
		},
		async saveData() {
			try {
				this.formErrors = [];

				this.$store.commit("setLoading", {
					show: true,
					label: this.modelTitle,
					description: "Salvando, aguarde...",
				});

				const schema = this.getValidationSchema();
				if (!schema) {
					throw new Error('Schema de validação não encontrado');
				}

				await schema.validate(this.data, {
					abortEarly: false,
				});

				if (this.data?.id) {
					await Axios.put(`${this.urlSaveData}/${this.data.id}`, { ...this.data });
				} else {
					await Axios.post(`${this.urlSaveData}`, { ...this.data });
				}

				this.getDataList();
				this.closeModal();
				this.showSuccessMessage();

			} catch (error) {
				if (error.name === "ValidationError") {
					this.showValidationErrors(error);
				} else {
					this.showApiErrorMessage(error);
				}
			} finally {
				this.$store.commit("setLoading", {
					show: false,
				});
			}
		},
		openAddModal() {
			this.setDataByType();
			this.modalOpen = true;
		},
		closeModal() {
			this.modalOpen = false;
			this.setDataByType();
		},
	},
	async mounted() {
		await this.initializeRegistrationType();
		await this.getDataList();
	},
}
</script>

<style scoped>
.registration-title {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}

.registration-form {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-gap: 15px;
  align-content: start;
}

.registration-form .field-error {
  padding: 0.25rem;
  color: var(--danger);
}

.crm-button.add-contact {
  background-color: #1b84e7;
}
.crm-button.add-contact:hover {
  background-color: #5b93d3;
  color: white;
}
.text-color-primary {
  color: var(--header-text-color-hover);
}

</style>

<style>
.alert-validate-name{
  width: 800px !important;
}
</style>